import { render, staticRenderFns } from "./CampaignStatus.vue?vue&type=template&id=39c7c7f5&scoped=true&"
import script from "./CampaignStatus.vue?vue&type=script&lang=ts&"
export * from "./CampaignStatus.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignStatus.vue?vue&type=style&index=0&id=39c7c7f5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c7c7f5",
  null
  
)

export default component.exports